import { createAction, props } from '@ngrx/store';

export const loadDownloadEmployeesUpdateHistoryDocuments = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUpdateHistoryDocuments',
  props<{ documentName: string; isSuccess: boolean }>()
);

export const loadDownloadEmployeesUpdateHistoryDocumentsSuccess = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUpdateHistoryDocuments Success',
  props<{ response: any }>()
);

export const loadDownloadEmployeesUpdateHistoryDocumentsFailure = createAction(
  '[BulkEmployeesUpdateHistory] Load DownloadEmployeesUpdateHistoryDocuments Failure',
  props<{ error: Error | any }>()
);
